export default __webpack_public_path__ + "static/media/finance.2a23905f.png";